<div *ngIf="!isSectionValid" class="margin-bottom-2">
    <ui-banner variant="info">
        <p>The fields marked in red are dependent on each other. Please match the other fields.</p>
    </ui-banner>
</div>
<div *ngFor="let humiColumn of section | keyvalue: originalKeyValueOrder">
    <app-mapping-table-section-column
        [sectionColumn]="humiColumn.value"
        (triggerValidation)="setIsSectionValid()"
    ></app-mapping-table-section-column>
</div>
